module.exports = __webpack_public_path__ + "static/media/user_say.708126b4.svg";